const Footer=()=>{
    return (<>
    <footer id="footer" className="footer position-relative dark-background">
        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <a href="#" className="d-flex align-items-center">
                <span className="sitename">CA Sanjay Prasad & Associates</span>
              </a>
              <div className="footer-contact pt-3">
                <p>F-2/275, Shiv Durga Vihar, Lakkarpur, Surajkund</p>
                <p>Faridabad, Haryana-121009, INDIA</p>
                <p className="mt-3"><strong>Phone :</strong> +91-9910668717</p>
                <p><strong>Email :</strong> contact@caspassociates.com, caspassociates01@gmail.com</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <a href="#">About Us</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Expertise</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Philosophy</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Our Vission & Mission</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-4 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Audit & Assurance</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Management Consultancy Services</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Corporate Law Advisory</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Accounting</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#">Tax Advisory</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-11">
              <h4>Follow Us</h4>
              <p>See what’s new – fresh updates, insights, and more on our website.</p>
              <div className="social-links d-flex">
                <a href="#"><i className="bi bi-twitter-x"></i></a>
                <a href="#"><i className="bi bi-facebook"></i></a>
                <a href="#"><i className="bi bi-instagram"></i></a>
                <a href="#"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div className="container copyright text-center mt-4">
          <p>
            © Copyright <strong className="px-1 sitename">Sanjay Prasad & Associates</strong> All Rights Reserved
          </p>
          <div className="credits">Developed by <a href="#">Softwebms@gmail.com</a></div>
        </div>
      </footer>
    </>);
}

export default Footer;